import { Component, Input } from '@angular/core';

import { ProductDetailsHeaderComponent } from '../../product/product-details-header/product-details-header.component';
import { ProductCtoBlockComponent } from '../../product/product-cto-block/product-cto-block.component';
import { SearchResult } from '../../../../graphql/generated/generated-types';
import { AssetPreviewPipe } from '../../../pipes/asset-preview.pipe';
import { RouterLink } from '@angular/router';
import { ProductImageWrapperComponent } from '../../product/product-image-wrapper/product-image-wrapper.component';
import { ItemListParamsComponent } from '../../item-list-params/item-list-params.component';
import { GalleryComponent } from '../../gallery/gallery.component';


@Component({
  selector: 'app-search-result-item',
  standalone: true,
  imports: [ProductDetailsHeaderComponent,  ProductCtoBlockComponent, 
    AssetPreviewPipe, RouterLink, ProductImageWrapperComponent, ItemListParamsComponent, GalleryComponent],
  templateUrl: './search-result-item.component.html',
  styleUrl: './search-result-item.component.scss'
})
export class SearchResultItemComponent {
  @Input() showSaveAction!: boolean;
  @Input() searchResult!: SearchResult;

  public studdedTires: boolean
  public studdableTires: boolean;
  ngOnInit(): void {
    this.hasStuddableTireAttribute();
    this.hasStuddedTyreAttribute();
  }

  public hasStuddableTireAttribute() {
    if (this.searchResult?.customAttributes?.productAttributes) {
      const studdableTire = this.searchResult.customAttributes.productAttributes.some(
        (attribute: { code: string; value: string }) => attribute.code === 'tire-studdable' && attribute.value === 'Yes'
      );
      this.studdableTires = studdableTire;
    } else {
      this.studdableTires = false;
    }

  }


  public hasStuddedTyreAttribute() {
    if (this.searchResult?.customAttributes?.productAttributes) {
      const studdableTire = this.searchResult.customAttributes.productAttributes.some(
        (attribute: { code: string; value: string }) => attribute.code === 'tire-studded' && attribute.value === 'Yes'
      );
      this.studdedTires = studdableTire;
    } else {
      this.studdedTires = false;
    }

  }

}
